import { createSlice } from "@reduxjs/toolkit";
import { FrameSettings } from "../types/core";
import { pingFrame } from "../actions/sharedActions";

export interface FrameState {
  data: Record<string, FrameSettings>;
  status: Record<string, "idle" | "loading" | "succeeded" | "failed">;
  backgroundStatus: Record<
    string,
    "idle" | "loading" | "succeeded" | "failed"
  >;
  error: Record<
    string,
    {
      status: number;
      headers: Record<string, string>;
      body: any;
    } | null
  >;
}

const initialState: FrameState = {
  data: {},
  status: {},
  backgroundStatus: {},
  error: {},
};

const frameSlice = createSlice({
  name: "frame",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(pingFrame.pending, (state, action) => {
        if (action.meta.arg.background) {
          state.backgroundStatus[action.meta.arg.frame_id] = "loading";
          return;
        }
        const { frame_id } = action.meta.arg;
        state.status[frame_id] = "loading";
        state.error[frame_id] = null;
      })
      .addCase(pingFrame.fulfilled, (state, action) => {
        if (action.meta.arg.background) {
          state.backgroundStatus[action.meta.arg.frame_id] = "succeeded";
        }
        const { frame_id } = action.meta.arg;
        state.status[frame_id] = "succeeded";
        state.data[frame_id] = action.payload.data.settings;
      })
      .addCase(pingFrame.rejected, (state, action) => {
        if (action.meta.arg.background) {
          state.backgroundStatus[action.meta.arg.frame_id] = "failed";
        }
        const { frame_id } = action.meta.arg;
        state.status[frame_id] = "failed";
        state.error[frame_id] = action.payload || {
          status: 500,
          headers: {},
          body: { message: "Unknown error" },
        };
      });
  },
});

export const frameReducer = frameSlice.reducer;
